import { push } from 'react-router-redux'
import { routes } from '../constants/routesConstants'
import { createStoreRoute } from '../routes/routeUtils'

export function selectNavigation(navigation, storeCode) {
  return push(createStoreRoute(routes.CATEGORY(navigation.id), storeCode))
}

export function selectTag(tag, storeCode) {
  return push(createStoreRoute(routes.TAG(tag), storeCode))
}

export function returnToMenu(storeCode) {
  return push(createStoreRoute(routes.MENU(), storeCode))
}

export function selectNavigationProduct(navigation, product, storeCode) {
  return push(createStoreRoute(routes.CATEGORY_PRODUCT(navigation.id, product.productCode), storeCode))
}

export function selectTagProduct(tag, product, storeCode) {
  return push(createStoreRoute(routes.TAG_PRODUCT(tag, product.productCode), storeCode))
}
